import {Injectable} from "@angular/core";
import {UserProfileService} from "@shared/services/api/user-profile.service";
import {LoggedInUser} from "@shared/services/api/logged-in-user";
import {ClientId, UserEntityType} from "../api/user-entity";
import {SiteInfo} from "@shared/services/api/access-sites.interface";

/**
 * This service serves as a hub for feature controls, when a new feature switch is introduced, a new method should be added for that feature with clear name,
 * and when the feature is later released to everyone, the feature method should be removed.
 */
@Injectable({providedIn: 'root'})
export class FeatureService {
  private readonly DEV_CIM_USER_ID = 'ca89cde3-6cac-4197-a5ad-aa966295c66d';
  private readonly LEND_LEASE_CLIENT_IDS = new Set<ClientId>([
    37,  // Lendlease Retail
    110, // Lendlease Commercial
    122, // Lendlease
    127, // JLL Lendlease Commercial
    148, // LendLease Digital
    150, // Lendlease Podium
    289, // Arup Lendlease
    295  // Intelle Building Services Lendlease
  ]);

  constructor(private userProfileService: UserProfileService) {
  }

  private get currentUser(): LoggedInUser | null {
    return this.userProfileService.getLoggedInUser();
  }

  private get isLicensor(): boolean {
    return this.currentUser?.isLicenser() ?? false;
  }

  private get isCimCompanyUser(): boolean {
    return this.currentUser?.userEntity?.id === 1 && this.currentUser?.userEntity?.type === UserEntityType.CUSTOMER;
  }

  private get isDevCimUser(): boolean {
    return this.currentUser?.userId === this.DEV_CIM_USER_ID;
  }

  timeTakenEnabled(site: SiteInfo): boolean {
    return this.isLicensor
      && (site.clients?.some(clientId => this.LEND_LEASE_CLIENT_IDS.has(clientId)) ?? false);
  }

  ticketReportTimeInFaultEnabled(): boolean {
    return true;
  }
}
